import { createElement, init } from "@airwallex/components-sdk";

export function registerAirwallexCheckout() {
    window.Alpine.data("airwallexCheckout", (config = {}) => ({
        intentId: config.intentId,
        clientSecret: config.clientSecret,
        elementId: config.elementId,
        currency: config.currency || "USD",
        env: config.env || "prod",
        onSuccess: config.onSuccess || null,
        onError: config.onError || null,

        async init() {
            await init({
                env: this.env,
                enabledElements: ["payments"],
            });

            const dropIn = await createElement("dropIn", {
                intent_id: this.intentId,
                client_secret: this.clientSecret,
                currency: this.currency,
                methods: ["card", "alipaycn", "alipayhk"],
                autoSaveCardForFuturePayments: false,
                savedPaymentMethod: {
                    saveMode: "none",
                },
                appearance: {
                    mode: "light",
                    variables: {
                        colorBrand: "#E74C3C",
                    },
                },
            });

            dropIn.mount(this.elementId);

            dropIn.on("ready", (event) => {
                //
            });

            dropIn.on("success", (event) => {
                if (this.onSuccess) {
                    this.onSuccess(event.detail);
                } else {
                    console.log("Payment successful", event.detail);
                }
            });

            dropIn.on("error", (event) => {
                const { error } = event.detail;
                if (this.onError) {
                    this.onError(error);
                } else {
                    console.error("Airwallex error", error);
                }
            });
        },
    }));
}
